
import {
  getVirtualTenantList,
  trailerInfo,
  // getDriverOilForPayWay,
} from 'api/operate';

let _this = null;

export default {
  sendThis: (scope) => {
    _this = scope;
  },
  form: [
    {
      value: 'split',
      allCustom: true,
    },
    {
      label: '车牌号',
      value: 'chooseVehicle',
      default: {},
      slot: true,
      hide: true,
    },
    {
      value: 'split',
      allCustom: true,
    },
    {
      label: '司机',
      value: 'chooseDriver',
      default: {},
      slot: true,
      hide: true,
    },
    {
      value: 'split',
      allCustom: true,
    },

    // 挂车信息（如果是牵引车，要输入挂车车牌）
    {
      label: '挂车车牌',
      value: 'chooseTrailer',
      type: 'el-autocomplete',
      valueKey: 'trailerNumber',
      disabled: false,
      hide: true,
      querySearchAsync: (queryString, cb) => {
        let resTrailer = [];
        if (queryString && queryString.length) {
          trailerInfo({ trailerNumber: queryString }).then((res) => {
            if (res && res.items) {
              resTrailer = res.items;
            }
            cb(resTrailer);
          });
        }
        cb(resTrailer);
      },
      onSelect: (item) => {
        _this.$refs.baseForm.setVal('dispatchTrailerInfo', item);
      },
    },
    {
      label: '挂车信息',
      value: 'dispatchTrailerInfo',
      type: 'select',
      default: {},
      slot: true,
      hide: true,
    },
    {
      value: 'split',
      allCustom: true,
    },

    // 非自有车 --- start
    {
      label: '是否代收',
      value: 'isAgent',
      type: 'select',
      default: false,
      hide: true,
      options: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],
      onChange: () => {
        _this.isAgentChange();
      },
    },
    {
      label: '代理人id',
      value: 'agentId',
      type: 'input',
      default: 0,
      readonly: true,
      hide: true,
    },
    {
      label: '收款人手机',
      value: 'agentPhone',
      type: 'el-autocomplete',
      valueKey: 'mobilePhone',
      hide: true,
      querySearchAsync: (queryString, cb) => _this.querySearchAsync(queryString, cb),
      onSelect: (item) => _this.querySearchOnSelect(item),
    },
    {
      label: '收款人',
      value: 'agentAccountName',
      type: 'el-autocomplete',
      valueKey: 'linkman',
      hide: true,
      querySearchAsync: (queryString, cb) => _this.querySearchAsync(queryString, cb),
      onSelect: (item) => _this.querySearchOnSelect(item),
    },
    // 非自有车 --- end
    // 自有车 --- start
    {
      label: '成本模式',
      value: 'paymentWay',
      type: 'radio',
      onChange: () => {
        _this.handlePaymentWayChange();
      },
    },
    {
      value: 'split',
      allCustom: true,
    },
    // {
    //   label: '油账户余额',
    //   value: 'oilBalance',
    //   placeholder: '请输入油账户余额',
    //   type: 'input',
    //   unit: '元',
    // },
    {
      label: '载重油耗',
      value: 'oilCostPer',
      placeholder: '请输入载重油耗',
      type: 'input',
      unit: '升/百公里',
      hide: true,
    },
    {
      label: '空载油耗',
      value: 'emptyOilCostPer',
      placeholder: '请输入空载油耗',
      type: 'input',
      unit: '升/百公里',
      hide: true,
    },
    {
      value: 'split',
      allCustom: true,
    },
    {
      value: 'contractChart',
      default: {},
      allCustom: true,
      hide: true,
    },
  ],
  rules: {
    chooseVehicle: [
      { required: true, message: '请选择车辆', trigger: 'blur' },
      {
        validator: (rule, value, callback) => _this.checkObjEmpty(rule, value, callback, '请选择车辆'),
        trigger: 'blur',
      },
    ],
    chooseDriver: [
      { required: true, message: '请选择主驾', trigger: 'blur' },
      {
        validator: (rule, value, callback) => _this.checkObjEmpty(rule, value, callback, '请选择主驾'),
        trigger: 'blur',
      },
    ],
    chooseTrailer: [
      { required: true, message: '请选择挂车', trigger: 'blur' },
      {
        validator: (rule, value, callback) => _this.checkObjEmpty(rule, value, callback, '请选择挂车'),
        trigger: 'blur',
      },
    ],
  },
  methods: {
    // 车牌号改变
    handleVehicleChange (formDataContract) {
      const chooseVehicle = _this.$refs.baseForm.getVal('chooseVehicle') || {};
      _this.setFormAttrVal({
        form: _this.baseForm,
        attr: 'hide',
        value: true,
        names: [
          'chooseDriver', 'paymentWay', 'oilCostPer', 'emptyOilCostPer', 'chooseTrailer',
          'localUserName', 'localPhone', 'guidePrice', 'totalFee',
          'toTenantName', 'acctName', 'acctNo',
          'isAgent', 'agentPhone', 'agentAccountName',
          'contractChart',
        ],
      });
      // 如果有司机信息，自动填入
      if (chooseVehicle.driverUserId) {
        _this.$refs.baseForm.setVal('chooseDriver', {
          userId: chooseVehicle.driverUserId,
          linkman: chooseVehicle.linkman,
          loginAcct: chooseVehicle.mobilePhone,
        });
      }

      if (chooseVehicle.vehicleCode) {

        if (Number(chooseVehicle.licenceType) === 2) {
          // 如果是牵引车，要选择挂车
          _this.setFormAttrVal({
            form: _this.baseForm,
            attr: 'hide',
            value: false,
            names: ['chooseTrailer'],
          });
        }

        if (Number(chooseVehicle.vehicleClass) === 1) {
          // 自有车，展示 成本模式
          _this.setFormAttrVal({
            form: _this.baseForm,
            attr: 'hide',
            value: false,
            names: ['chooseDriver', 'paymentWay'],
          });
          _this.handlePaymentWayChange(formDataContract);
        } else {
          // 非自有车，展示 是否代收（收款手机，收款人） 和 图表
          _this.setFormAttrVal({
            form: _this.baseForm,
            attr: 'hide',
            value: false,
            names: ['chooseDriver', 'isAgent', 'contractChart'],
          });
          _this.isAgentChange();

          _this.$nextTick(() => {
            // 图表需要计算各种费用
            _this.$refs.contract.getLevelAndSetSomeScales(chooseVehicle.vehicleClass, formDataContract);
          });
        }
      }
    },
    // 司机改变
    handleDriverChange () {
      // TODO
    },
    // 点击成本模式（智能模式：1，报账模式：2，承包模式：3）
    handlePaymentWayChange (formDataContract) {
      _this.setFormAttrVal({
        form: _this.baseForm,
        attr: 'hide',
        value: true,
        names: ['oilCostPer', 'emptyOilCostPer', 'contractChart'],
      });
      const paymentWay = _this.$refs.baseForm.getVal('paymentWay');
      if (Number(paymentWay) === 1) {
        // 智能模式，展示 智能图表
      }
      if (Number(paymentWay) === 2) {
        // 报账模式，展示 载重油耗 和 空载油耗
        _this.setFormAttrVal({
          form: _this.baseForm,
          attr: 'hide',
          value: false,
          names: ['oilCostPer', 'emptyOilCostPer'],
        });
      }
      if (Number(paymentWay) === 3) {
        // 承包模式，展示 承包图表
        _this.setFormAttrVal({
          form: _this.baseForm,
          attr: 'hide',
          value: false,
          names: ['contractChart'],
        });

        _this.$nextTick(() => {
          const chooseVehicle = _this.$refs.baseForm.getVal('chooseVehicle') || {};
          _this.$refs.contract.getLevelAndSetSomeScales(chooseVehicle.vehicleClass, formDataContract);
        });
      }
    },

    // 是否代收
    isAgentChange () {
      const isAgent = _this.$refs.baseForm.getVal('isAgent');
      _this.setFormAttrVal({
        form: _this.baseForm,
        attr: 'hide',
        value: !isAgent,
        names: ['agentPhone', 'agentAccountName'],
      });
    },
    // 输入关键字来查询相关信息
    querySearchAsync (queryString, cb) {
      let resList = [];
      if (queryString && queryString.length) {
        getVirtualTenantList({
          name: queryString,
          includeDriver: false,
        }).then((res) => {
          if (res && res.items) {
            resList = res.items;
          }
          cb(resList);
        });
      }
      cb(resList);
    },
    // 点击选择其中一项
    querySearchOnSelect (item) {
      // _this.otherFormData.receiverUserInfo = item;
      _this.$refs.baseForm.setVal('agentPhone', item.mobilePhone);
      _this.$refs.baseForm.setVal('agentAccountName', item.linkman);
      _this.$refs.baseForm.setVal('agentId', item.userId);
    },
  },
};
